<template>
  <div class="my-5">
    <Label>{{ label }}</Label>
    <select
      :name="name"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      class="mt-2 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <slot />
    </select>
  </div>
</template>

<script setup>
import { Label } from "@/components/ui/label";

defineProps({
  label: { type: String, required: true },
  name: { type: String, required: true },
  modelValue: { type: [String, Number], default: "" },
});

defineEmits(["update:modelValue"]);
</script>
